import styled, { css } from 'styled-components';
import { SELECT_MENU_MAX_HEIGHT_PX } from '../constants';
import { SELECT_MENU_TRANSITION_DURATION_MILLIS } from './constants';
import SelectMenuContents from './SelectMenuContents';
import { ContentsStyleProps } from './types';

const transitionStyles = {
  entering: 'opacity: 1; transform: translateY(0);',
  entered: 'opacity: 1; transform: translateY(0);',
  exiting: 'opacity: 0; transform: translateY(-10px);',
  exited: 'opacity: 0; transform: translateY(-10px);',
  unmounted: '',
};

const simplebarStyles = `
  .simplebar-wrapper,
  .simplebar-mask {
    border-radius: inherit;
  }

  .simplebar-track.simplebar-vertical {
    top: 5px;
    bottom: 5px;
  }
`;

export const selectMenuStyle = css<ContentsStyleProps>`
  transition: ${({ theme }) =>
    theme.transitions.create(
      ['opacity', 'transform'],
      `${SELECT_MENU_TRANSITION_DURATION_MILLIS}ms`,
      'ease-in-out',
    )};

  ${({ $transitionStatus }) => transitionStyles[$transitionStatus]}
  ${simplebarStyles}
`;

export const Contents = styled(SelectMenuContents)<ContentsStyleProps>`
  ${selectMenuStyle};
  overflow: hidden;

  .select-menu-scroller {
    max-height: ${SELECT_MENU_MAX_HEIGHT_PX}px;
  }
`;
